import { Button } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import { useState } from 'react';

function DownloadExcelButton({
  onDownload,
  isDisabled = false,
  size = 'xs',
  label = 'Download Excel',
}) {
  const [downloading, setDownloading] = useState(false);

  return (
    <Button
      size={size}
      variant="outline"
      colorScheme="purple"
      isDisabled={isDisabled}
      isLoading={downloading}
      onClick={async (event) => {
        event.stopPropagation();
        setDownloading(true);
        try {
          await onDownload();
        } finally {
          setDownloading(false);
        }
      }}
    >
      {label}
    </Button>
  );
}

DownloadExcelButton.propTypes = {
  onDownload: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  size: PropTypes.string,
  label: PropTypes.string,
};

export default DownloadExcelButton;
